import { CORE_ACTION } from "../types/CoreAction";

const closeDialog = () => {
  return {
    type: CORE_ACTION.CLOSE_DIALOG,
    payload: {},
  };
};

export default closeDialog;
